import React from "react"
import styled from "styled-components"
import { type ArbeidsarkIconKeys, SVGIcon } from "~/components"
import type { BaseProps } from "~/types/props"

interface WrapperProps extends Pick<StatusMessageProps, "type"> {}

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  justify-self: center;
  align-self: center;
  justify-content: center;
  align-content: center;
  padding: 1rem 2rem;
  margin: 12px 0px;
  border-radius: 1rem;
  width: calc(335px - 4rem);
  ${(props) =>
    props.type === "success" &&
    `
    color: ${props.theme.colors.gray0};
    border: solid 3px ${props.theme.colors.success90};
    background-color: ${props.theme.colors.success99};

    .status-icon > svg {
      fill: ${props.theme.colors.success20};
    }
    `}

  ${(props) =>
    props.type === "warning" &&
    `
      color: ${props.theme.colors.gray0};
      border: solid 3px ${props.theme.colors.warning70};
      background-color: ${props.theme.colors.warning90};

      .status-icon > svg {
        fill: ${props.theme.colors.warning20};
      }
  `}

  ${(props) =>
    props.type === "error" &&
    `
      color: ${props.theme.colors.gray0};
      border: solid 3px ${props.theme.colors.error90};
      background-color: ${props.theme.colors.error99};

      .status-icon > svg {
        fill: ${props.theme.colors.error20};
      }
  `}
  svg {
    margin-right: 10px;
  }

  ${(props) => props.theme.media.mobile} {
    width: fill-available;
  }
`

interface MessageWrapperProps {
  centerMessage?: boolean
}
const MessageWrapper = styled.div<MessageWrapperProps>`
  display: flex;
  flex-direction: row;
  flex: 1;

  ${(props) =>
    props.centerMessage &&
    `
    justify-content: center;
  `}
`

const ChildWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`

interface StatusMessageProps extends BaseProps {
  type: "success" | "warning" | "error"
  icon?: ArbeidsarkIconKeys
  message?: string | React.ReactNode

  centerMessage?: boolean
}

export const StatusMessage: React.CFC<StatusMessageProps> = ({
  type,
  icon,
  message,
  children,
  centerMessage = false,
  ...props
}) => {
  return (
    <Wrapper type={type}>
      {icon || message ? (
        <MessageWrapper {...props} centerMessage={centerMessage}>
          {icon ? <SVGIcon className="status-icon" icon={icon} /> : ""}
          {message ? message : ""}
        </MessageWrapper>
      ) : (
        ""
      )}
      {children ? <ChildWrapper>{children}</ChildWrapper> : ""}
    </Wrapper>
  )
}
